import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Order } from 'shell/view-models/order';
import { ResearchResponsibleVM } from 'practice/view-models/research-responsible';

export const transformDataset = (values: ResearchResponsibleVM): string => {
  const transformedFilters: OperationObject = {
    codiceServizio: { value: values.filter?.codeService || '', operation: Operation.LIKE },
    codResponsabile: {
      value: values.filter?.codeResponsible || '',
      operation: Operation.LIKE,
    },
    tipoPratica: {
      value: values.filter?.typePractice || '',
      operation: Operation.EQUALS,
    },
  };

  const ordersToTransform = values.filter?.orders || {};
  const ordersMapped: Order = {
    codiceServizio: ordersToTransform?.service,
    codResponsabile: ordersToTransform?.responsible,
    tipoPratica: ordersToTransform?.practice,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
